import background from "./background.png";
import logo from "./logo.png";
import illustration from "./Illustration.png";
import success from "./success.png";
import coverbg from "./coverbg.png";

export const assets = {
  background,
  logo,
  illustration,
  success,
  coverbg,
};
